const _excluded = ["size", "isResizing", "children", "tableSize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
const StyledTD = styledC.td.withConfig({
  displayName: "TableCell__StyledTD",
  componentId: "sc-18ip4dp-0"
})(["width:", ";flex:", ";display:flex;align-items:center;height:100%;border-bottom:1px solid ", ";padding:0 ", "px;border-right:1px solid ", ";background-color:", ";& a{text-decoration:none;color:inherit;width:", ";flex:", ";display:flex;align-items:center;height:100%;}"], _ref => {
  let {
    size
  } = _ref;
  return typeof size === 'number' ? "".concat(size, "px") : size;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size + ' 0 auto';
}, theme.tokens.colors.border.subtler.value, _ref3 => {
  let {
    cellPadding
  } = _ref3;
  return cellPadding;
}, _ref4 => {
  let {
    isResizing
  } = _ref4;
  return isResizing ? theme.tokens.colors.border.selected.subtle.value : 'transparent';
}, theme.tokens.colors.background.primary.value, _ref5 => {
  let {
    size
  } = _ref5;
  return typeof size === 'number' ? "".concat(size, "px") : size;
}, _ref6 => {
  let {
    size
  } = _ref6;
  return size + ' 0 auto';
});
const TableCell = _ref7 => {
  let {
      size,
      isResizing,
      children,
      tableSize
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded);
  const tableSizeTheme = getTableTheme(tableSize);
  return /*#__PURE__*/React.createElement(StyledTD, _extends({
    role: "cell",
    size: size,
    $isResizing: isResizing,
    tabIndex: -1,
    cellPadding: tableSizeTheme.cellPadding
  }, props), children);
};
TableCell.propTypes = {
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isResizing: PropTypes.bool,
  children: PropTypes.any,
  style: stylePropType
};
export default TableCell;
//# sourceMappingURL=TableCell.js.map